import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "33",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "#000",
        d: "M6.033 1.805c-.387.473-1.005.846-1.624.793-.077-.64.225-1.319.58-1.739C5.376.373 6.052.027 6.6 0c.065.666-.187 1.319-.567 1.805m.56.92c-.895-.054-1.662.525-2.087.525-.432 0-1.083-.499-1.792-.486-.922.014-1.78.553-2.25 1.412-.966 1.719-.251 4.263.684 5.662.457.692 1.005 1.452 1.727 1.425.683-.027.954-.46 1.779-.46.831 0 1.07.46 1.792.446.747-.013 1.218-.692 1.675-1.385.522-.786.735-1.552.748-1.592-.013-.013-1.444-.58-1.457-2.284C7.4 4.563 8.54 3.883 8.592 3.843c-.645-.985-1.65-1.092-1.998-1.119M11.77.792v10.383h1.56v-3.55h2.16c1.972 0 3.357-1.398 3.357-3.423S17.486.793 15.54.793zm1.56 1.359h1.798c1.354 0 2.127.745 2.127 2.058s-.773 2.064-2.133 2.064h-1.792zm8.366 9.104c.98 0 1.889-.513 2.301-1.325h.032v1.245h1.444V6.008c0-1.499-1.16-2.464-2.945-2.464-1.657 0-2.881.979-2.927 2.324h1.406c.116-.64.69-1.059 1.476-1.059.953 0 1.488.46 1.488 1.305v.573l-1.946.12c-1.811.113-2.79.88-2.79 2.211 0 1.346 1.011 2.238 2.461 2.238m.42-1.232c-.832 0-1.36-.413-1.36-1.046 0-.652.508-1.032 1.482-1.092l1.733-.113v.586c0 .972-.799 1.665-1.856 1.665M27.398 14c1.521 0 2.237-.6 2.862-2.418l2.74-7.939h-1.586l-1.837 6.135h-.032l-1.837-6.135h-1.631l2.643 7.56-.142.46c-.239.779-.625 1.078-1.315 1.078-.122 0-.361-.013-.458-.026v1.245c.09.027.477.04.593.04"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h33v14H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }